<div class="audit-detail-panel">
  <!-- Header -->
  <div class="detail-header">
    <div class="d-flex justify-content-between align-items-center">
      <h5 class="mb-0">Event Details</h5>
      <button
        kendoButton
        class="cyflare-btn-secondary cyflare-btn-icon"
        (click)="onClose()"
        title="Close"
      >
        ✕
      </button>
    </div>
  </div>

  <!-- Content -->
  @if (event(); as evt) {
    <div class="detail-content">
      <!-- Event Summary -->
      <div class="detail-section">
        <h6 class="section-title">Event Summary</h6>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="label">Request ID</span>
            <span class="value font-monospace small">{{ evt.request_id }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Time</span>
            <span class="value">{{ evt.event_time | date:'medium' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Action</span>
            <span class="value">
              <span class="badge bg-primary">{{ evt.action }}</span>
            </span>
          </div>
          <div class="detail-item">
            <span class="label">Outcome</span>
            <span class="value">
              <span
                class="badge"
                [class.bg-success]="evt.outcome.toLowerCase() === 'success'"
                [class.bg-warning]="evt.outcome.toLowerCase() === 'validation_failed'"
                [class.bg-danger]="['denied', 'error'].includes(evt.outcome.toLowerCase())"
              >
                {{ evt.outcome }}
              </span>
            </span>
          </div>
          <div class="detail-item">
            <span class="label">HTTP Status</span>
            <span class="value">{{ evt.http_status }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Endpoint</span>
            <span class="value font-monospace small">{{ evt.method }} {{ evt.endpoint }}</span>
          </div>
        </div>
      </div>

      <!-- Actor Info -->
      <div class="detail-section">
        <h6 class="section-title">Actor Information</h6>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="label">User Email</span>
            <span class="value">{{ evt.user_email || '—' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">User Type</span>
            <span class="value">{{ evt.user_type }}</span>
          </div>
          <div class="detail-item">
            <span class="label">IP Address</span>
            <span class="value font-monospace">{{ evt.ip_address || '—' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">User Agent</span>
            <span class="value small text-break">{{ evt.user_agent || '—' }}</span>
          </div>
        </div>
      </div>

      <!-- Organization Context -->
      <div class="detail-section">
        <h6 class="section-title">Organization Context</h6>
        <div class="detail-grid">
          <div class="detail-item">
            <span class="label">Organization</span>
            <span class="value">{{ evt.organization_name }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Organization Type</span>
            <span class="value">{{ evt.organization_type || '—' }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Event Type</span>
            <span class="value">{{ evt.event_type }}</span>
          </div>
          <div class="detail-item">
            <span class="label">Entity</span>
            <span class="value">
              @if (evt.entity_type) {
                {{ evt.entity_type }} ({{ evt.entity_id }})
              } @else {
                —
              }
            </span>
          </div>
        </div>
      </div>

      <!-- Changes (Diff) -->
      @if (evt.tier === 2 && evt.diff_json) {
        <div class="detail-section">
          <h6 class="section-title">Changes</h6>
          @if (evt.change_summary) {
            <p class="text-muted small mb-3">{{ evt.change_summary }}</p>
          }
          <div class="table-responsive">
            <table class="table table-sm table-bordered mb-0">
              <thead class="table-light">
                <tr>
                  <th>Field</th>
                  <th>Old Value</th>
                  <th>New Value</th>
                </tr>
              </thead>
              <tbody>
                @for (entry of getDiffEntries(); track entry.field) {
                  <tr>
                    <td class="fw-semibold">{{ entry.field }}</td>
                    <td class="text-danger">{{ formatValue(entry.old) }}</td>
                    <td class="text-success">{{ formatValue(entry.new) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      <!-- Errors -->
      @if (evt.error_code || evt.error_message || evt.validation_errors) {
        <div class="detail-section">
          <h6 class="section-title text-danger">Error Information</h6>
          <div class="detail-grid">
            @if (evt.error_code) {
              <div class="detail-item">
                <span class="label">Error Code</span>
                <span class="value font-monospace text-danger">{{ evt.error_code }}</span>
              </div>
            }
            @if (evt.error_message) {
              <div class="detail-item">
                <span class="label">Error Message</span>
                <span class="value text-danger">{{ evt.error_message }}</span>
              </div>
            }
            @if (evt.validation_errors) {
              <div class="detail-item full-width">
                <span class="label">Validation Errors</span>
                <div class="value">
                  @for (field of Object.keys(evt.validation_errors); track field) {
                    <div class="text-danger small">
                      <strong>{{ field }}:</strong> {{ evt.validation_errors[field].join(', ') }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  } @else {
    <div class="detail-content text-center py-5">
      <p class="text-muted">No event selected</p>
    </div>
  }
</div>
